import { render, staticRenderFns } from "./policeAcademyMore.vue?vue&type=template&id=56319acb&scoped=true&"
import script from "./policeAcademyMore.vue?vue&type=script&lang=js&"
export * from "./policeAcademyMore.vue?vue&type=script&lang=js&"
import style0 from "./policeAcademyMore.vue?vue&type=style&index=0&id=56319acb&lang=scss&scoped=true&"
import style1 from "./policeAcademyMore.vue?vue&type=style&index=1&id=56319acb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56319acb",
  null
  
)

export default component.exports